// Переключатель дизайна: classic (по умолчанию) / cp. Старая версия — simple-modal.styled.classic.js, новая — simple-modal.styled.cp.js
import { isCp } from 'libs/design';
import * as classic from './simple-modal.styled.classic';
import * as cp from './simple-modal.styled.cp';

export const Content = isCp ? cp.Content : classic.Content;
export const Place = isCp ? cp.Place : classic.Place;
export const SimpleModalButtons = isCp ? cp.SimpleModalButtons : classic.SimpleModalButtons;
export const SimpleModalTitle = isCp ? cp.SimpleModalTitle : classic.SimpleModalTitle;
